import { entity } from 'jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'schools' })
export class School extends HierarchyNode {}
